import { StudentProblemResult } from '@yandex-int/k-common/typings';
import { Text } from 'platform-components';
import React from 'react';

import { EmptyAttempts } from '../_student-attempts-value/empty-attempts';

export const InfinityAttempts = ({ studentProblemResult }: { studentProblemResult: StudentProblemResult }) => (
    <Text weight={Text.WEIGHT.L}>{studentProblemResult.attempt_number || <EmptyAttempts />}</Text>
);
